<template>
  <div class="dark-label">
    <v-img class="background" :src="require('../assets/dark parchment background.jpg')">
    <v-container fluid>
      <v-row style="font-weight:600; align-items:center;">
        <v-col sm="4" class="mb-2">
          <v-autocomplete
            v-if="admin"
            v-model="sendTargets"
            :items="names"
            label="Send Targets"
            multiple
            outlined
            dense
            dark
            clearable
            hide-details
            background-color="brown darken-4"
            :menu-props="{nudgeTop: 2,}"
            class="custom-autocomplete"
          ></v-autocomplete>

          <v-autocomplete
            v-else
            v-model="sendTargets"
            :items="names"
            label="Send Targets"
            multiple
            outlined
            dense
            dark
            clearable
            background-color="brown darken-4"
            :menu-props="{nudgeTop: 2,}"
            class="custom-autocomplete absolute-hint"
            :hint="'Rolls Left: ' + rollsLeft"
            persistent-hint
          ></v-autocomplete>
          </v-col>
          <v-col md="1" sm="2">
          <v-text-field style="text-align-last:center" background-color="brown darken-4" dark v-model="rollAmount" id="rollAmount" label="Roll Amount" autocomplete="off"></v-text-field>
        </v-col>
         <v-col md="7" sm="5" style="text-align:right">
          <v-btn dark v-if="admin" @click="showClassExpDialog = !showClassExpDialog">Account Experience</v-btn>
          <v-dialog v-model="showClassExpDialog">
            <class-exp-dialog :players="players" :username="username" :password="password" style="overflow:hidden"></class-exp-dialog>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
    <v-row>
      <v-col md="4" sm="12">
        <v-card height="275px" :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Utility Rolls </v-card-title>
          <v-row>
            <v-col cols="12" sm="4">        
              <v-btn elevation="1" class="mb-1 mt-2 ml-2" style="width:140px" outlined text @click="roll('class')">Roll Class</v-btn>
              <v-btn elevation="1" class="mb-1 mt-2 ml-2" text style="width:140px" outlined :style="`color: ${storeOpen ? 'white' : ''};background-color:${storeOpen ? 'darkred' : ''}`" @click="openStoreDialog">Roll Store</v-btn> <br/>
              <v-btn elevation="1" class="mb-1 mt-2 ml-2" style="width:140px" outlined text @click="levelUp()">Level Up</v-btn>         
            </v-col>
            <v-col cols="12" sm="8" class="mt-2">
              <v-row style="margin-left:4px;; align-items:baseline">
                <v-text-field @focus="$event.target.select()" class="mt-3" dense v-model="goldAmount" style="max-width:70px; max-height:30px"></v-text-field>
                <v-btn small outlined text elevation="1" class="ml-2" @click="giveGold" style="width:80px">Give Gold</v-btn>      
              </v-row> 
              <v-row style="margin-left:4px;; align-items:center">
                <v-text-field @focus="$event.target.select()" class="mt-3" dense v-model="xpAmount" style="max-width:70px; max-height:30px"></v-text-field>
                <v-btn small outlined text elevation="1" class="ml-2" @click="giveXP" style="width:80px">Give XP</v-btn>
                <div>
                  <v-checkbox class="small-label" dense height="11px" v-model="targetSendXp" label="Target Send (exp)"></v-checkbox>
                  <v-checkbox class="small-label" dense height="11px" v-model="ignoreLeveling" label="Ignore Leveling"></v-checkbox>
                </div>
              </v-row>    
              <v-row style="align-items:center;" class="pt-2 pb-0 mb-0 mt-6">          
                
              </v-row>                       
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-card-actions style="justify-content:center;" class="mt-4">          
            <v-btn style="width:125px" elevation="1" class="ma-1" outlined text @click="rollLoot('small')">Small Pile</v-btn>
                <v-btn style="width:125px" elevation="1" class="ma-1" outlined text @click="rollLoot('medium')">Medium Pile</v-btn>
                <v-btn style="width:125px" elevation="1" class="ma-1" outlined text @click="rollLoot('large')">Large Pile</v-btn>           
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col md="5" sm="12">
        <v-card height="275px" :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="max-height:48px; color:white"> 
            <v-row>
              <v-col sm="4"> Loot </v-col>
              <v-col sm="8">
                <v-tabs v-model="lootTab" class="color-tab" fixed-tabs background-color="headline brown darken-4" align-tabs="center" dark>
                  <v-tabs-slider style="height:30px"/>
                  <v-tab>Potions</v-tab>
                  <v-tab>Gear</v-tab>
                </v-tabs>
              </v-col>
            </v-row>
          </v-card-title>
          <v-row style="width:100%" class="mr-0 ml-0">
            <v-col cols="12" sm="4" class="ml-0 mt-2">   
              <v-row class="pt-4 pb-4">
                <v-row class="ml-0">
                  <v-col sm="4" class="pb-0">
                    <v-checkbox class="small-label" dense height="11px" v-model="potionOptions.types.curative" label="Curative"></v-checkbox>
                    <v-checkbox class="small-label" dense height="11px" v-model="potionOptions.types.mnemonic" label="Mnemonic"></v-checkbox>                    
                  </v-col>
                  <v-col sm="4" class="pb-0" style="">
                    <v-checkbox class="small-label" dense height="11px" v-model="potionOptions.types.restorative" label="Restorative"></v-checkbox>
                    <v-checkbox class="small-label" dense height="11px" v-model="potionOptions.types.ressurective" label="Resurrective"></v-checkbox>
                  </v-col>
                  <v-col sm="4" class="pb-0" style="align-self:center">
                    <v-checkbox class="small-label" dense height="11px" style="text-align:center" v-model="potionOptions.amount.ignoreLevel" label="Ignore Level"></v-checkbox>
                  </v-col>
                </v-row>
                <v-row style="justify-content:center; align-items:center" class="mt-2">
                  <v-text-field @focus="$event.target.select()" class="mt-3" dense v-model="potionOptions.amount.potionMin" style="max-width:30px; max-height:30px; text-align-last:center"></v-text-field>
                  <div style="align-self:end" class="pb-1">—</div>
                  <v-text-field @focus="$event.target.select()" class="mt-3" dense v-model="potionOptions.amount.potionMax" style="max-width:30px; max-height:30px; text-align-last:center"></v-text-field>
                  <v-btn small text elevation="1" @click="randomPotions" style="width:140px" class="mt-1 ml-2">Roll Potions</v-btn>      
                </v-row>
              </v-row>
              <v-row class="pt-2 pb-4">
                <v-col>
                  <v-row>
                    <v-col sm="4" class="pb-0">
                      <v-checkbox class="small-label" dense height="11px" v-model="gear.type.grenade" label="Grenade"></v-checkbox>
                      <v-checkbox class="small-label" dense height="11px" v-model="gear.type.blanch" label="Blanch"></v-checkbox>                      
                    </v-col>
                    <v-col sm="5" class="pb-0">     
                      <v-checkbox class="small-label" dense height="11px" v-model="gear.type.ammunition" label="Ammunition"></v-checkbox>
                      <v-checkbox class="small-label" dense height="11px" v-model="gear.type.implement" label="Implement"></v-checkbox>
                    </v-col>
                    <v-col sm="3" class="pb-0 pl-0">
                      <v-checkbox class="small-label" dense height="11px" v-model="gear.type.utility" label="Utility"></v-checkbox>   
                    </v-col>
                  </v-row>  
                  <v-row style="justify-content:center; align-items:center" class="mt-2">
                    <v-text-field @focus="$event.target.select()" class="mt-3" dense v-model="gear.amount.gearMin" style="max-width:30px; max-height:30px; text-align-last:center"></v-text-field>
                    <div style="align-self:end" class="pb-1">—</div>
                    <v-text-field @focus="$event.target.select()" class="mt-3" dense v-model="gear.amount.gearMax" style="max-width:30px; max-height:30px; text-align-last:center"></v-text-field>
                    <v-btn small elevation="1" class="mb-0 mt-1 ml-2" outlined text @click="rollGear()">Roll Gear</v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col sm="8" style="overflow-y:hidden; overflow-x:hidden; height:227px; width:100%; padding-right:0px" class="mt-3 br-2 firefoxScroll">
              <v-tabs-items v-model="lootTab" style="margin-top:-12px; background-color:transparent">
                <v-tab-item>

                  <v-tabs v-model="potionTab" class="small-tab" fixed-tabs background-color="headline brown darken-2" align-tabs="center" dark>
                    <v-tabs-slider style="height:30px"/>
                    <v-tab v-for="type in potionTabs" :key="type" style="font-size:10px; padding-left:0px; padding-right:0px">{{type}}</v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="potionTab" style="overflow-y:auto; height:197px; width:100%; padding-right:0px; padding-top:2px; background-color:transparent" class="light firefoxScroll">
                    <v-tab-item v-for="type in potionTabs" :key="type" style="margin-bottom:4px; margin-left:1px"> 
                      <div v-for="item in potions" v-bind:key="item.name">
                        <div v-if="item.type == type" style="display:flex; align-items:baseline">
                          {{item.name}}: {{item.count}}
                          <v-spacer/>
                          <v-btn dense dark color="brown darken-1" class="mt-0 mb-1 pa-0" height="30px" x-small @click="givePotion(item)" style="align-items:start; align-self:center"><v-icon style="font-size:32px; bottom:1px">mdi-plus</v-icon></v-btn>
                          <v-btn dense dark color="brown darken-1" class="mt-0 mb-1 ml-1" height="30px" x-small @click="givePotion(item, -1)" style="align-items:start; align-self:center" width="30px"><v-icon style="font-size:32px;">mdi-minus</v-icon></v-btn>
                          <v-btn dense dark color="brown darken-1" class="mt-0 mb-1 ml-1 pa-0" height="30px" @click="itemInfo = true; focusedInfoItem = item">Info</v-btn>  
                        </div>
                      </div> 
                    </v-tab-item>
                  </v-tabs-items> 
                </v-tab-item>

                <v-tab-item>
                  <v-tabs v-model="gearTab" class="small-tab" fixed-tabs background-color="headline brown darken-2" align-tabs="center" dark>
                    <v-tabs-slider style="height:30px"/>
                    <v-tab v-for="type in gearTabs" :key="type" style="font-size:10px; padding-left:0px; padding-right:0px">{{type}}</v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="gearTab" style="overflow-y:auto; height:197px; width:100%; padding-right:0px; background-color:transparent" class="light firefoxScroll">
                    <v-tab-item v-for="type in gearTabs" :key="type" style="margin-bottom:4px; margin-left:1px; padding-top:2px;">
                      <div v-for="item in playerGear" v-bind:key="item.name">
                        <div v-if="item.type == type" style="display:flex; align-items:baseline">
                          {{item.name}}: {{item.count}}
                          <v-spacer/>
                          <v-btn dense dark color="brown darken-1" class="mt-0 mb-1" height="30px" x-small width="30px" @click="giveGear(item, 1)" style="align-items:start; align-self:center"><v-icon style="font-size:32px; bottom:1px">mdi-plus</v-icon></v-btn>
                          <v-btn dense dark color="brown darken-1" class="mt-0 ml-1 mb-1" height="30px" x-small width="30px" @click="giveGear(item, -1)" style="align-items:start; align-self:center"><v-icon style="font-size:32px; bottom:1px">mdi-minus</v-icon></v-btn>
                          <v-btn dense dark color="brown darken-1" class="mt-0 mb-1 ml-1 pa-0" height="30px" @click="itemInfo = true; focusedInfoItem = item">Info</v-btn>  
                        </div>
                      </div>  
                    </v-tab-item>
                  </v-tabs-items>                         
                </v-tab-item>
              </v-tabs-items>              
            </v-col>        
          </v-row>        
          <v-overlay :absolute="true" v-model="itemInfo" style="display:flex; align-content:center">
            <v-card >
              <v-card-title>
                {{focusedInfoItem.name}}: {{focusedInfoItem.count}} 
                <v-spacer/>                  
                <v-btn icon @click="itemInfo = false">x</v-btn>                
              </v-card-title>
              <v-card-text>
              <span v-if="focusedInfoItem.stack" style="white-space: pre-wrap"
              >Per Stack: {{focusedInfoItem.stack}}<br/>
                <span style="white-space: pre-wrap">{{focusedInfoItem.longDesc}}</span>
              </span>
              <span v-else
              >Potion Level: {{focusedInfoItem.minLvl}}  
              <br/>{{focusedInfoItem.effect}}  
              </span>              
              </v-card-text>                 
            </v-card>
          </v-overlay>  
        </v-card>        
      </v-col>

      <v-col md="3" sm="12">
        <v-card height="275px" :img="require('../assets/parchment background.jpg')" style="">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Wonderous Items</v-card-title>
          <v-row style="margin-top:-8px">
            <v-col cols="12" sm="4" >
              <div v-for="item in getItemList(wonderousItems.rarity)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(wonderousItems.rarity, item)" @mousedown="wonderousItems.rarity[item] = !wonderousItems.rarity[item]" @click="wonderousItems.rarity[item] = !wonderousItems.rarity[item]" draggable="false">
                   <v-checkbox dense class="mt-0 mb-0" height="9px" v-model="wonderousItems.rarity[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
<!-- ring:true, neck:true, eyes:true, belt:true, hands:true, shoulders:true, chest:true, headband:true, body:true, feet:true, none:true, -->
            <v-col cols="12" sm="3">
              <div v-for="item in getItemList(wonderousItems.type,0,7)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(wonderousItems.type, item)" @mousedown="wonderousItems.type[item] = !wonderousItems.type[item]" @click="wonderousItems.type[item] = !wonderousItems.type[item]" draggable="false">
                   <v-checkbox dense class="mt-0 mb-0" height="4px" v-model="wonderousItems.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <div v-for="item in getItemList(wonderousItems.type,7,15)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(wonderousItems.type, item)" >
                   <v-checkbox dense class="mt-0 mb-0" height="4px" v-model="wonderousItems.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined text @click="roll('wonderousItems')">Roll</v-btn>            
            <v-btn elevation="1" outlined text @click="check(wonderousItems, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text @click="check(wonderousItems, 'none')">uncheck</v-btn>
            <v-btn elevation="1" outlined text @click="rollPartyDrop()">Party Drop</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col sm="12" md="2">
        <v-card height="275px" :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Stats </v-card-title>
          <v-row class="mt-1">
            <v-col cols="12" sm="5">
               <div v-for="item in getItemList(stats.rarity)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(stats.rarity, item)" @mousedown="stats.rarity[item] = !stats.rarity[item]" @click="stats.rarity[item] = !stats.rarity[item]" draggable="false">
                   <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="stats.rarity[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>              
            </v-col>

            <v-col cols="12" sm="7">
              <div v-for="item in getItemList(stats.type)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(stats.type, item)" @mousedown="stats.type[item] = !stats.type[item]" @click="stats.type[item] = !stats.type[item]" draggable="false">
                   <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="stats.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div> 

            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn  elevation="1" outlined text small @click="roll('stats')">Roll</v-btn>
            <v-btn elevation="1" outlined text small @click="check(stats, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text small @click="check(stats, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col sm="12" md="2">
        <v-card height="275px" :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Feats </v-card-title>
          <v-row class="mt-1">
            <v-col cols="6" sm="4">
              <div v-for="item in getItemList(feats, 0, 4)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(feats, item)" @mousedown="feats[item] = !feats[item]" @click="feats[item] = !feats[item]" draggable="false">
                   <v-checkbox dense class="mt-1 mb-1" height="11px" v-model="feats[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>               
              
            </v-col>
            <v-col cols="6" sm="6" class="ml-4">
              <span class="ml-2" style="font-weight:600">
              Rare Types:
              </span>
              <div v-for="item in getItemList(feats, 4, 6)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(feats, item)" @mousedown="feats[item] = !feats[item]" @click="feats[item] = !feats[item]" draggable="false">
                   <v-checkbox dense class="mt-1 mb-1" height="11px" v-model="feats[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>                  
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined small  text @click="roll('feats')">Roll</v-btn>
            <v-btn elevation="1" outlined small text @click="check(feats, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined small text @click="check(feats, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col sm="12" md="4">
        <v-card height="275px" dense :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Perks ({{perkCount}})</v-card-title>
          <v-row no-gutters class="mt-1">
            <v-col cols="3" sm="4" >
              <div v-for="item in getItemList(perks.type)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(perks.type, item)" @mousedown="perks.type[item] = !perks.type[item]" @click="perks.type[item] = !perks.type[item]" draggable="false">
                   <v-checkbox dense class="mt-1 mb-1" height="11px" v-model="perks.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
            <v-col cols="3" sm="4"> 
              <div v-for="item in getItemList(perks.rarity, 0,5)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(perks.rarity, item)" @mousedown="perks.rarity[item] = !perks.rarity[item]" @click="perks.rarity[item] = !perks.rarity[item]" draggable="false">
                   <v-checkbox dense class="mt-1 mb-1" height="11px" v-model="perks.rarity[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>         
            </v-col>
            <v-col cols="3" sm="4">
              <span style="font-weight:600">
              Single Choice Options:
              </span>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="perks.sub.recoveryPerks" @click="unselectSub('recoveryPerks')" label="Recovery Perk"></v-checkbox>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="perks.sub.ragePerks" @click="unselectSub('ragePerks')" label="Rage Power"></v-checkbox>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="perks.sub.roguePerks" @click="unselectSub('roguePerks')" label="Rogue Talent"></v-checkbox>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="perks.sub.kiPerks" @click="unselectSub('kiPerks')" label="Ki Power"></v-checkbox>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="perks.sub.fighterPerks" @click="unselectSub('fighterPerks')" label="Fighter Perk"></v-checkbox>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="perks.rarity.forbidden" @click="unselectSub('forbidden')" label="Forbidden"></v-checkbox>
            </v-col>
          </v-row>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined text @click="roll('perks')">Roll</v-btn>
            <v-btn elevation="1" outlined text @click="check(perks, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text @click="check(perks, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col sm="12" md="4">
        <v-card height="275px" dense :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Armor </v-card-title>
          <v-row no-gutters class="mt-1">
            <v-col cols="3" sm="4" >
              <div v-for="item in getItemList(armorFull.armor.type)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(armorFull.armor.type, item)" @mousedown="armorFull.armor.type[item] = !armorFull.armor.type[item]" @click="armorFull.armor.type[item] = !armorFull.armor.type[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="armorFull.armor.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
            <v-col cols="3" sm="4" >
              <div v-for="item in getItemList(armorFull.armor.rarity)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(armorFull.armor.rarity, item)" @mousedown="armorFull.armor.rarity[item] = !armorFull.armor.rarity[item]" @click="armorFull.armor.rarity[item] = !armorFull.armor.rarity[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="armorFull.armor.rarity[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
            <v-col cols="3" sm="4" >
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="armorFull.armor.enchanted" label="Enchanted"></v-checkbox>
            </v-col>
          </v-row>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined text @click="roll('armor')">Roll</v-btn>
            <v-btn elevation="1" outlined text @click="check(armorFull.armor, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text @click="check(armorFull.armor, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col sm="12" md="4">
        <v-card height="275px" dense :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Armor Enchantments </v-card-title>
          <v-row no-gutters class="mt-1">
            <v-col cols="3" sm="4" >
              <div v-for="item in getItemList(armorFull.armorEnchantments)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(armorFull.armorEnchantments, item)" @mousedown="armorFull.armorEnchantments[item] = !armorFull.armorEnchantments[item]" @click="armorFull.armorEnchantments[item] = !armorFull.armorEnchantments[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="armorFull.armorEnchantments[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>          
            </v-col>
          </v-row>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined text @click="roll('armorEnchantments')">Roll</v-btn>
            <v-btn elevation="1" outlined text @click="check(armorFull.armorEnchantment, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text @click="check(armorFull.armorEnchantment, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col sm="12" md="4">
        <v-card height="275px" dense :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Weapons  ({{weaponCount}})</v-card-title>
          <v-row no-gutters class="mt-1">
            <v-col cols="2" sm="3" >
              <div v-for="item in getItemList(weaponFull.weapon.rarity)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(weaponFull.weapon.rarity, item)" @mousedown="weaponFull.weapon.rarity[item] = !weaponFull.weapon.rarity[item]" @click="weaponFull.weapon.rarity[item] = !weaponFull.weapon.rarity[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weapon.rarity[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
            <v-col cols="3" sm="3" >
              <span class="ma-1 mb-4"><b>Melee Types:</b></span>
              <div v-for="item in getItemList(weaponFull.weapon.type, 0,4)" :key="item" draggable="false" class="mt-1">
                <div @mouseenter="maybeToggle(weaponFull.weapon.type, item)" @mousedown="weaponFull.weapon.type[item] = !weaponFull.weapon.type[item]" @click="weaponFull.weapon.type[item] = !weaponFull.weapon.type[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weapon.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>         
            </v-col>
            <v-col cols="3" sm="3" >
              <span class="ma-1 mb-4"><b>Ranged Types:</b></span>
                <div v-for="item in getItemList(weaponFull.weapon.type, 4,7)" :key="item" draggable="false" class="mt-1">
                <div @mouseenter="maybeToggle(weaponFull.weapon.type, item)" @mousedown="weaponFull.weapon.type[item] = !weaponFull.weapon.type[item]" @click="weaponFull.weapon.type[item] = !weaponFull.weapon.type[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weapon.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>  
            </v-col>
            <v-col cols="2" sm="2" >
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weapon.class.enchanted" label="Enchanted"></v-checkbox>
              <!-- <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weapon.class.melee" label="Melee"></v-checkbox>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weapon.class.ranged" label="Ranged"></v-checkbox>            -->
            </v-col>
          </v-row>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined text @click="roll('weapon')">Roll</v-btn>
            <v-btn elevation="1" outlined text @click="check(weaponFull.weapon, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text @click="check(weaponFull.weapon, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col sm="12" md="4">
        <v-card height="275px" dense :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Weapon Enchantment </v-card-title>
          <v-row no-gutters class="mt-1">
            <v-col cols="3" sm="4" >
              <div v-for="item in getItemList(weaponFull.weaponEnchantments.rarity)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(weaponFull.weaponEnchantments.rarity, item)" @mousedown="weaponFull.weaponEnchantments.rarity[item] = !weaponFull.weaponEnchantments.rarity[item]" @click="weaponFull.weaponEnchantments.rarity[item] = !weaponFull.weaponEnchantments.rarity[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weaponEnchantments.rarity[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>         
            </v-col>
            <v-col cols="3" sm="4">
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weaponEnchantments.class.melee" label="Melee"></v-checkbox>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weaponEnchantments.class.ranged" label="Ranged"></v-checkbox>
              <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weaponEnchantments.class.armament" label="Armament"></v-checkbox>
              <!-- <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="weaponFull.weaponEnchantments.class.ammo" label="Ammo"></v-checkbox>                -->
            </v-col>
          </v-row>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined text @click="roll('weaponEnchantments')">Roll</v-btn>
            <v-btn elevation="1" outlined text @click="check(weaponFull.weaponEnchantments, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text @click="check(weaponFull.weaponEnchantments, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col sm="12" md="4">
        <v-card height="420px" dense :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Spells ({{spellCount}})
          </v-card-title>
          <v-row no-gutters class="mt-1">
            <v-col>
              <v-row no-gutters>
              <v-col cols="6" sm="6">
                <div class="ml-1" >
                  <div @click="spells.specific=false">
                    <v-checkbox dense class="mt-0 mb-0" height="11px" label="Automatic" v-model="spells.automatic" ></v-checkbox>
                  </div>

                  <div style="display: flex; align-items: baseline;">
                Level Modifier: <v-text-field style="text-align:center; max-width:35px; text-align-last: center;" single-line class="ml-1" v-model="spells.modifierAmount" type="number" max="7" min="-9" dense></v-text-field>
                </div>

                </div>
              </v-col>
                <v-col cols="6" sm="6" >
                  <div @click="spells.automatic=false;">
                    <v-checkbox dense class="mt-0 mb-0" height="11px" label="Specific" v-model="spells.specific"></v-checkbox>
                  </div>

                  <div v-for="item in getItemList(spells.level)" :key="item" draggable="false">
                    <div @mouseenter="maybeToggle(spells.level, item)" @mousedown="spells.level[item] = !spells.level[item]" @click="spells.level[item] = !spells.level[item]" draggable="false">
                      <v-checkbox :disabled="!spells.specific" dense class="mt-0 mb-0" height="7px" v-model="spells.level[item]" :label="`Level ${item[item.length-1]}`" draggable="false"></v-checkbox>
                    </div>
                  </div>
                </v-col>
            </v-row> 
          </v-col>
            <v-col cols="3" sm="4" >
              <div v-for="item in getItemList(spells.type)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(spells.type, item)" @mousedown="spells.type[item] = !spells.type[item]" @click="spells.type[item] = !spells.type[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="spells.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>              
            </v-col>
          </v-row>

          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined text @click="roll('spells')">Roll</v-btn>
            <v-btn elevation="1" outlined text @click="check(spells, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text @click="check(spells, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
        </v-col>
        
        <v-col sm="12" md="8">
        <v-card height="420px" dense :img="require('../assets/parchment background.jpg')">
          <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white"> Maneuvers ({{maneuverCount}})</v-card-title>
          <v-row no-gutters class="mt-1">
          <v-col cols="3" sm="3">
          <v-row no-gutters>
            <v-col cols="6" sm="6">
              <div class="ml-1" >
                <div @click="maneuver.specific=false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" label="Automatic" v-model="maneuver.automatic" ></v-checkbox>
                </div>
                <div style="display: flex; align-items: baseline;">
                Level Modifier: <v-text-field style="text-align:center; max-width:35px; text-align-last: center;" single-line class="ml-1" v-model="maneuver.modifierAmount" type="number" max="7" min="-9" dense></v-text-field>
                </div>

              </div>
            </v-col>
              <v-col cols="6" sm="6" >
                <div @click="maneuver.automatic=false;">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" label="Specific" v-model="maneuver.specific"></v-checkbox>
                </div>

                <div v-for="item in getItemList(maneuver.level)" :key="item" draggable="false">
                  <div @mouseenter="maybeToggle(maneuver.level, item)" @mousedown="maneuver.level[item] = !maneuver.level[item]" @click="maneuver.level[item] = !maneuver.level[item]" draggable="false">
                    <v-checkbox :disabled="!maneuver.specific" dense class="mt-0 mb-0" height="11px" v-model="maneuver.level[item]" :label="`Level ${item[item.length-1]}`" draggable="false"></v-checkbox>
                  </div>
                </div>
              </v-col>
          </v-row>
            </v-col>

            <v-col cols="2" sm="2">
               <div v-for="item in getItemList(maneuver.school, 0, 10)" :key="item" draggable="false">
                  <div @mouseenter="maybeToggle(maneuver.school, item)" @mousedown="maneuver.school[item] = !maneuver.school[item]" @click="maneuver.school[item] = !maneuver.school[item]" draggable="false">
                    <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="maneuver.school[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                  </div>
                </div>   
                                                                                
            </v-col>
            <v-col cols="2" sm="2" >
              <div v-for="item in getItemList(maneuver.school, 10, 20)" :key="item" draggable="false">
                  <div @mouseenter="maybeToggle(maneuver.school, item)" @mousedown="maneuver.school[item] = !maneuver.school[item]" @click="maneuver.school[item] = !maneuver.school[item]" draggable="false">
                    <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="maneuver.school[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                  </div>
                </div>
   
                                       
            </v-col>
            <v-col cols="2" sm="2" >
              <div v-for="item in getItemList(maneuver.school, 20, 30)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(maneuver.school, item)" @mousedown="maneuver.school[item] = !maneuver.school[item]" @click="maneuver.school[item] = !maneuver.school[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="maneuver.school[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
            <v-col cols="2" sm="2" >
              <div v-for="item in getItemList(maneuver.type)" :key="item" draggable="false">
                <div @mouseenter="maybeToggle(maneuver.type, item)" @mousedown="maneuver.type[item] = !maneuver.type[item]" @click="maneuver.type[item] = !maneuver.type[item]" draggable="false">
                  <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="maneuver.type[item]" :label="capitalize(item)" draggable="false"></v-checkbox>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-card-actions style="bottom:0; position:absolute">
            <v-btn elevation="1" outlined text @click="roll('maneuver')">Roll</v-btn>
            <v-btn elevation="1" outlined text @click="check(maneuver, 'all')">check all</v-btn>
            <v-btn elevation="1" outlined text @click="check(maneuver, 'none')">uncheck</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="6" sm="12">
          <v-card height="400px" dense >
            <v-card-title class="headline brown darken-4 pt-2 pb-2" style="color:white">
              Log 
              <v-spacer/>
              <v-btn elevation="1" class="ml-6" outlined dark small text @click="fullLog= !fullLog">Toggle Full Log</v-btn>
            </v-card-title>   

            <v-list style="height:325px; overflow-y:auto; background-color:antiquewhite" class="light">
              <div v-for="log in visibleLogs" v-bind:key="log.id">
                <v-list-item><li> {{log.text}}</li></v-list-item>
              </div>
            </v-list>
          </v-card>
      </v-col>
      <v-col md="6" sm="12">
          <v-card height="400" elevation="2" style="background:antiquewhite">
          <v-card-title style="color:white; max-height:56px" class="headline brown darken-4"> 
            Group Notes
          </v-card-title>
            <v-textarea @change="$emit('sendNotes', groupNotes)" v-model="groupNotes" dense rows="12" hide-details no-resize style="background-color:antiquewhite" class="ma-0 light">
            </v-textarea>
          </v-card>
        </v-col>
    </v-row>

    <v-dialog persistent v-model="newError.new">
      <v-card>
        <v-card-title class="headline grey lighten-2"> Error </v-card-title>
          <v-card-text>
            <div v-if="newError.message">{{newError.message}}</div>
            <div v-else>
              Rolling error of type {{newError.type}} to {{newError.target}}
              </div>
          </v-card-text>
          <v-card-actions @click="newError.new = false">Okay</v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="storeDialog" >
      <store-dialog      
      :players="players"
      :storeOpen="storeOpen"
      :storeCommand="storeCommand"
      @giveGear="giveGear"
      @givePotion="givePotion"
      @sendData="sendData"
      @requestRoll="requestRoll"
      @swapStore="swapStore"
      ></store-dialog>
    </v-dialog>
    </v-img>
  </div>
</template>

<script>
import dataGenerator from "./dataGenerator"
import StoreDialog from "./storeDialog"
import classExpDialog from "./classExpDialog"
import {potions as potionsList, maneuvers, weapons, perks, gear, spells,} from "./data"
//import { weaponEnchantments } from './data';
export default {
  components: {
    StoreDialog,
    classExpDialog,
  },
  props: {
    players: [],
    rollRequests: {},
    newCommand:{},    
    admin: Boolean,
    username:String,
    password:String,
  },
  data() {
    return {
      rollsLeft:400,
      //admin: true,
      newError:{
        new:false,
        type:"",
        target:""
      },
      mouseDown:false,
      logs:[],
      fullLog:false,
      storeDialog:false,
      showClassExpDialog:false,
      goldAmount:0,
      xpAmount:0,
      ignoreLeveling:false,
      targetSendXp:false,
      storeOpen: false,
      storeCommand: {},
      focusedPotion:"curative",
      lootTab:0,
      potionTab:0,
      potionTabs:["curative","mnemonic","restorative","ressurective"],
      gearTab:0,
      gearTabs:["ammunition","grenade","blanch","utility","implement"],
      itemInfo:false,
      focusedInfoItem:{},
      potions:[],
      playerGear:[],
      groupNotes:``,
      potionOptions:{
        amount:{
          potionMin:2,
          potionMax:4,
          ignoreLevel:false
        },
        types:{
          curative:true,
          mnemonic:true,
          restorative:true,
          ressurective:false,
        }
      },
      gear: {
        amount:{
          gearMin:1,
          gearMax:2,
        },
        type:{
          grenade:true,
          blanch:true,
          utility:true,
          ammunition:true,
          implement:true,
        }
      },
      rollIds:0,
      sendTargets: [],
      rollAmount: 3,
      wonderousItems: {
        rarity:{
          common: true,
          rare: true,
          epic: true,
          legendary: true,
          unique:true,
        },
        type:{
          ring:true,
          neck:true,
          eyes:true,
          belt:true,
          hands:true,
          shoulders:true,
          chest:true,
          headband:true,
          body:true,
          feet:true,
          head:true,
          wrist:true,
          untyped:true,
          //none:true,
        }

      },
      stats: {
        rarity:{
          common: true,
          rare: true,
          epic: true,
          legendary: true,
          unique:true,
        },
        type:{
          abilityScore:true,
          skills:true,
         // saves:true,
          misc:true,          
        }

      },
      feats: {
        martial: true,
        magic: true,
        utility: true,
        style: true,
        teamwork: true,
        metamagic: true,
      },
      perks: {
        type:{
          martial: true,
          magic: true,
          universal: true,  
        },
        rarity:{
          common: true,
          rare: true,
          epic: true,
          legendary: true,
          unique: true,
          forbidden: false,
        },
        sub:{
          ragePerks: false,
          recoveryPerks: false,
          roguePerks: false,
          kiPerks: false,
          fighterPerks: false
        }
      },
      armorFull:{
        armor: {
          type:{
            clothing:true,
            light: true,
            medium: true,
            heavy: true,
            shield: true,
          },
          rarity:{
            common: true,
            rare: true,
            epic: true,
            legendary: true,
            unique: true,
          },
          enchanted: false,
        },
        armorEnchantments: {
          common: true,
          rare: true,
          epic: true,
          legendary: true,
          unique: true,
        },
      },
      weaponFull:{
        weapon: {
          rarity:{
            common: true,
            rare: true,
            epic: true,
            legendary: true,     
            unique:true      
          },
          class:{
            enchanted: false,
            // melee: true,
            // ranged: true,
          },
          type:{
            augmenting:true,
            light: true,
            oneHanded:true,
            twoHanded:true,
            primitive:true,
            tech:true,
            armament:true,
          }
        },
        weaponEnchantments: {
          rarity:{
            common: true,
            rare: true,
            epic: true,
            legendary: true,
            unique: true,
          },
          class: {
            melee: true,
            ranged: true,
            armament: true,
            all: true,
          }
        },
      },      
      spells: {
        modifierAmount:0,
        specific:false,
        automatic:true,
        level:{
          lvl0: true,
          lvl1: true,
          lvl2: true,
          lvl3: true,
          lvl4: true,
          lvl5: true,
          lvl6: true,
          lvl7: true,
          lvl8: true,
          lvl9: true,
        },
        type:{
          damage:true,
          control:true,
          utility:true,
          buff:true,
          healing:true,          
        },
      },
      maneuver: {
        modifierAmount:0,
        specific:false,
        automatic:true,
        level:{
          lvl1: true,
          lvl2: true,
          lvl3: true,
          lvl4: true,
          lvl5: true,
          lvl6: true,
          lvl7: true,
          lvl8: true,
          lvl9: true,
        },
        type:{
          Boost: true,
          Stance: true,
          Strike: true,
          Counter: true,
          Finisher:true,
        },
        school:{
          blackSeraph: true,
          brokenBlade: true,
          brutalCrocodile: true,
          burningCitadel: true,
          crimsonReaper: true,
          cursedRazor: true,
          elementalFlux: true,
          eternalGuardian: true,
          goldenLion: true,
          heartOfTheMaelstrom: true,
          indomitableWill: true,
          ironTortoise: true,
          mithralCurrent: true,
          piercingThunder: true,
          primalFury: true,
          radiantDawn: true,
          rivenHourglass: true,
          scarletThrone: true,
          shadowAssassin: true,
          shatteredMirror: true,
          silverCrane: true,
          sleepingGoddess: true,
          solarWind: true,
          steelSerpent: true,
          sterlingSovereignty: true,
          tempestGale: true,
          thrashingDragon: true,
          unquietGrave: true,
          veiledMoon: true,
        }
      },
    };
  },
  mounted() {
    //this.players.push({playerName:"cheems"})
    document.addEventListener("mousedown", ()=>{this.mouseDown = true})
    document.addEventListener("mouseup", ()=>{this.mouseDown = false})
    
    this.potions = potionsList
    this.potions.forEach(potion => {
      potion.count = 0
      if(potion.name == "Gem of Raise Dead"){
        potion.count = 1
      }
      })    
    this.playerGear = [...gear]
    this.playerGear.forEach(gear => gear.count = 0)
    window.onbeforeunload = function(){
      return 'You have a game running, are you sure you want to close?';
    }
  },
  computed: {
    names() {
      let names = ["all"];
      this.players.forEach((player) => {
        names.push(player.playerName);
      });
      return names;
    },
    visibleLogs(){      
      if(this.logs.length > 10 && this.fullLog==false){
        return this.logs.slice(0, 10)
      }else{
        return this.logs
      }
    },
    maneuverCount(){
      let levels = Object.keys(this.maneuver.level).filter(key=>this.maneuver.level[key])
      let types = Object.keys(this.maneuver.type).filter(key=>this.maneuver.type[key])
      let schools = Object.keys(this.maneuver.school).filter(key=>this.maneuver.school[key])
      return maneuvers.filter(maneuver=> types.includes(maneuver.type) && schools.includes(maneuver.school) && levels.includes("lvl" + maneuver.level)).length
    },
    spellCount(){
      // let noRepeats = spells.filter(function(item, pos) {
      //   return spells.findIndex(elem=> elem.name == item.name) == pos
      // })
      //console.log(JSON.stringify(noRepeats, null,4))
      let levels = Object.keys(this.spells.level).filter(key=>this.spells.level[key])
      let types = Object.keys(this.spells.type).filter(key=>this.spells.type[key])  
      return spells.filter(spell=> types.some(type=> spell.type.includes(type)) && levels.includes("lvl" + spell.level)).length
    
    },

    weaponCount(){
      let rarity = Object.keys(this.weaponFull.weapon.rarity).filter(key=>this.weaponFull.weapon.rarity[key])
      let types = Object.keys(this.weaponFull.weapon.type).filter(key=>this.weaponFull.weapon.type[key])
      return weapons.filter(weapon => types.some(type=> weapon.type.includes(type)) && rarity.includes(weapon.rarity)).length
    },

    perkCount(){
      let rarity = Object.keys(this.perks.rarity).filter(key=>this.perks.rarity[key])
      let types = Object.keys(this.perks.type).filter(key=>this.perks.type[key])
      let filtered = perks.filter(perk => types.some(type=> perk.type.includes(type)) && rarity.includes(perk.rarity))
      //let list = filtered.map(perk=>perk.name)
      //console.log(list)
      return filtered.length
    }
  },
  watch:{
    rollRequests(){
      // if(!this.admin){
      //   this.rollsLeft -= 1
      // }
      if (this.rollRequests.message.command == "requestRoll") {
        this.requestRoll(this.rollRequests.message, this.rollRequests.player)
      }else if(this.rollRequests.message.type == "requestWeaponEnchantment"){
        this.requestWeaponEnchantment(this.rollRequests.message, this.rollRequests.player)
      }             
    },

    newCommand(){
      if(this.newCommand.type == "newPlayer"){
        this.potions.forEach((potion)=>{
          if(potion.count > 0){
            this.newCommand.fromPlayer.senderConnection.send(JSON.stringify({command:"communalUpdate", type:"potion", potion}))
          }
        })
        this.playerGear.forEach(gear=>{
          if(gear.count > 0){
            this.newCommand.fromPlayer.senderConnection.send(JSON.stringify({command:"communalUpdate", type:"gear", gear}))
          }
        })
        if(this.storeOpen){
          this.storeCommand = {type:"newPlayer", connection:this.newCommand.fromPlayer.senderConnection}
          //this.newCommand.fromPlayer.senderConnection.send(JSON.stringify({command:"newRoll", type:"newStore", remainingItems:this.store.remainingItems}))
        }
      }else if(this.newCommand.type == "usedPotions"){
        this.logs.unshift({id:this.logs.length-1, text:this.potions[this.newCommand.potion.id-1].name + " was used by " + this.newCommand.fromPlayer.playerName })
        this.potions.splice(this.newCommand.potion.id-1, 1, this.newCommand.potion)
        this.players.forEach(player=>{
          if(player.playerName != this.newCommand.fromPlayer.playerName){
            this.sendData({command:"communalUpdate", type:"potion", potion:this.newCommand.potion}, player);
          }
        })
      }else if(this.newCommand.type == "usedGear"){
        this.logs.unshift({id:this.logs.length-1, text: this.newCommand.gear.name + " was used by " + this.newCommand.fromPlayer.playerName })
        let index = this.playerGear.findIndex(allGear=> allGear.name == this.newCommand.gear.name)
        let temp = this.playerGear[index]
        temp.count--
        this.playerGear.splice(index,1,temp)

        this.players.forEach(player=>{
          if(player.playerName != this.newCommand.fromPlayer.playerName){
            this.sendData({command:"communalUpdate", type:"gear", gear:this.newCommand.gear}, player);
          }
        })
      }else if(this.newCommand.type == "buyItem"){
        //this.logs.unshift({id:this.logs.length-1, text:this.store.remainingItems[this.newCommand.item].name + " was bought by " + this.newCommand.fromPlayer.playerName})
        this.storeCommand = {type:"itemBought", item:this.newCommand}
      }else if(this.newCommand.type == "sendGold"){
        this.logs.unshift({id:this.logs.length-1, text:this.newCommand.fromPlayer.playerName + " sent " + this.newCommand.gold + " gold"})
      }else if(this.newCommand.type == "getPotions"){
        this.newCommand.command(this.potions)
      }else if(this.newCommand.type == "getGear"){
        this.newCommand.command(this.playerGear)
      }else if(this.newCommand.type == "setItems"){
        if(this.newCommand.items.parsedPotions){
          for(let x = 0; x < this.newCommand.items.parsedPotions.length;x++){          
            let index = potionsList.findIndex(potion => potion.name == this.newCommand.items.parsedPotions[x].name)
            potionsList[index].count = this.newCommand.items.parsedPotions[x].count
          }
        }
        if(this.newCommand.items.parsedGear){
          for(let x = 0; x < this.newCommand.items.parsedGear.length;x++){          
            let index = this.playerGear.findIndex(gear => gear.name == this.newCommand.items.parsedGear[x].name)
            if(index == -1){
              this.playerGear.splice(0,0,this.newCommand.items.parsedGear[x])
            }else{
              this.playerGear[index].count = this.newCommand.items.parsedGear[x].count
            }
          }   
        }
      }else if(this.newCommand.type == "groupNotes"){
        this.groupNotes = this.newCommand.notes
      }else if(this.newCommand.type == "wonderousItemRolls"){
        this.logs.unshift({id:this.logs.length-1, text:this.newCommand.rollString})
      }
    }
  },

  methods: {
    roll(type) {
      this.players.forEach((player) => {
        if(this.sendTargets.includes(player.playerName) || this.sendTargets.includes("all")) {
          let data
          if(type == "weapon"){
            data = this['weaponFull']
          }else if(type == 'armor' || type == 'armorEnchantments'){
            data = this['armorFull']
          }else if(type == "weaponEnchantments"){
            let message = {}
            message.data = this.weaponFull.weaponEnchantments
            message.command = 'newRoll'
            message.type = 'requestWeapon'
            this.sendData(message, player);
            return
          }else{
            data = this[type]
          }
          let playerNames = this.players.map(player => player.playerName)
          let filteredPlayerNames = playerNames.filter(name => name != player.playerName)
          let playerFeats = []
          let playerPerks = []
          if(player.characterSheet.lists && player.characterSheet.lists.feats){
             playerFeats = player.characterSheet.lists.feats.map(feat=>feat.name)        
          }
          if(player.characterSheet.lists && player.characterSheet.lists.perks){
             playerPerks = player.characterSheet.lists.perks.map(perk=>perk.name)        
          }                    
          if(player.characterSheet && (type =="spells" || type =="maneuver") && !data.specific){
            let modAmount = parseInt(this[type].modifierAmount)
            modAmount = modAmount > 9 ? 9 : modAmount
            modAmount = modAmount < -9 ? -9 : modAmount
            let lvlNum = (Math.ceil(player.characterSheet.characterStats.misc.level/2)+1) + modAmount
            lvlNum = lvlNum < 1 ? 1 : lvlNum
            data = JSON.parse(JSON.stringify(data))
            data.level = this.getSpellManeuverLevel(lvlNum, type)
          }
          let options = this.getRoll(player.playerName, type, data, this.rollAmount, playerFeats, playerPerks, filteredPlayerNames)
          //console.log("options", options)
          let message = {}
          message.options = options
          message.command = 'newRoll'
          message.type = type
          if(options.length < this.rollAmount){
            console.log("error occured!", message)
          }else{
            this.sendData(message, player);
          }
        }
      });
    },

    getSpellManeuverLevel(lvlNum, type){
      let min = type == "spells" ? 0 : 1
      if(lvlNum > 9){lvlNum = 9}
      let options = {level:{}}
      for(let x = 0; x < 4; x++){
          if(lvlNum-x >= min){   
              let level = lvlNum-x
              let levelString="lvl"+level;
              options.level[levelString]=true;
          }
      }
      return options.level
    },

    sendData(message, player) { 
      
      if(this.rollsLeft < 1){
        this.newError.new = true
        this.newError.message = "Sorry you have reached your roll limit for a free game."
        this.newError.target = player
        return
      }
      if(!this.admin && message.command == "newRoll"){
        this.rollsLeft -= 1
      }

      message.rollId = Math.random()*1000000
      if(player.connected){
        player.senderConnection.send(JSON.stringify(message))
      }
      if(message.options && message.type !="requestWeapon" && message.type !="weaponEnchantment"){
        if(!player.remainingRolls) player.remainingRolls = []
        player.remainingRolls.splice(player.remainingRolls.length, 0, message)
      }else if(message.type == "gold"){
        player.characterSheet.gold += parseInt(message.amount)
        if(message.info){
          let filtered = player.characterSheet.lists.perks.filter(perk =>{
            return perk.name == "Treasure Sense"
          })
          filtered.forEach(()=>{            
            let multiplier = message.info == "small" ? 10 : message.info == "medium" ? 20 : 30
            player.characterSheet.gold += Math.ceil(Math.random()*multiplier)
          })
        }
      }else if(message.type == "xp"){
        player.characterSheet.xp += parseInt(message.amount)
      }      
      
    },

    check(obj, type){
      let set = type == 'all' ? true : false
      Object.entries(obj).forEach((entry)=>{
        if(typeof entry[1] == 'boolean'){
          obj[entry[0]] = set
        }else{
          Object.entries(entry[1]).forEach((subEntry)=>{
            obj[entry[0]][subEntry[0]] = set
          }) 
        }
      })
    },

    requestRoll(message, player){
      let options = {}
      //console.log("message1", message)
      if(message.type =="weapon"){
        options.weapon = {}
        options.weaponEnchantments = {}
        if(message.options && message.options.name) options.name == message.options.name
        if(message.options && message.options.weapon && message.options.weapon.rarity){
          options.weapon.rarity = message.options.weapon.rarity
        }else{
          options.weapon.rarity={common:true, rare:true,epic:true,legendary:true, unique:true}
        }
        if(message.options && message.options.weapon && message.options.weapon.type){
          options.weapon.type = message.options.weapon.type
        }else{
          options.weapon.type={augmenting:true, light: true, oneHanded:true, twoHanded:true, primitive:true, tech:true, armament:true}
        }
        if(message.options && message.options.weapon && message.options.weapon.class){
          options.weapon.class = message.options.weapon.class
        }else{
          options.weapon.class={melee:true, ranged:true,armament:true,enchanted:false}
        }
        if(message.options && message.options.weaponEnchantments && message.options.weaponEnchantments.rarity){
          options.weaponEnchantments.rarity = message.options.weaponEnchantments.rarity
        }else{
          options.weaponEnchantments.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        }
        if(message.options && message.options.weaponEnchantments && message.options.weaponEnchantments.class){
          options.weaponEnchantments.class = message.options.weaponEnchantments.class
        }else{            
          options.weaponEnchantments.class={melee:true, ranged:true, armament:true}
        }
      }else if(message.type=='armor'){        
        options = {armor:{type:{},rarity:{},enchanted:false},armorEnchantments:{}}        
        if(message.options && message.options.armor && message.options.armor.type){
          options.armor.type= message.options.armor.type
        }else{
          options.armor.type = {clothing:true, light:true,medium:true,heavy:true,shield:true}
        }
        if(message.options && message.options.armor && message.options.armor.rarity){
          options.armor.rarity = message.options.armor.rarity
        }else{
          options.armor.rarity = {common:true, rare:true,epic:true,legendary:true, unique:true}
        }
        if(message.options && message.options.armor && message.options.armor.enchanted){
          options.armor.enchanted = message.options.armor.enchanted
        }else{
          options.armor.enchanted = false          
        }
        if(message.options && message.options.armorEnchantments){
          options.armorEnchantments= message.options.armorEnchantments
        }else{
          options.armorEnchantments = {common:true, rare:true,epic:true,legendary:true,unique:true}
        }
      }else if(message.type=="stats"){
        options={rarity:{common:true, rare:true, epic:true, legendary:true, unique:true,}, type:{abilityScore:true, misc:true, skills:true}}
        if(message.options && message.options.type){
          options.type = message.options.type
        }
        if(message.options && message.options.rarity){
          options.rarity = message.options.rarity
        }
        
      }else if(message.type=="perks" || message.type=="Perk"){
        message.type="perks"
        if(message.options && message.options.rarity){
          options.rarity=message.options.rarity
        }else{
          options.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        }
        if(message.options && message.options.type){
          options.type = message.options.type
        }else{
          options.type={martial:true, magic:true,universal:true}
        }
        if(message.options && message.options.sub){
          options.sub = message.options.sub
        }else{
          options.sub= {ragePerks: false, recoveryPerks: false, roguePerks: false, kiPerks: false, fighterPerks: false}
        }
      }else if(message.type=="unique"){
        message.type="perks"
        options.rarity={common:false, rare:false,epic:false,legendary:false,unique:true}
        options.type={martial:true, magic:true,universal:true}
        options.sub= {ragePerks: false, recoveryPerks: false, roguePerks: false, kiPerks: false, fighterPerks: false}
      }else if(message.type=="feats" || message.type=="Feat"){      
        message.type="feats"
        if(message.options){
          options = message.options
        }else{
          options={martial:true, magic:true, utility:true, style:true, metamagic:true, teamwork:false}
        }
      }else if(message.type=="maneuver"){
        if(message.options && message.options.school){
          options.school = message.options.school
        }else{ 
          options.school = {blackSeraph: true, brokenBlade: true, brutalCrocodile:true, cursedRazor: true, elementalFlux: true, eternalGuardian: true, goldenLion: true, ironTortoise: true, mithralCurrent: true, piercingThunder: true, primalFury: true, radiantDawn: true, rivenHourglass: true, scarletThrone: true, shatteredMirror: true, silverCrane: true, sleepingGoddess: true, solarWind: true, steelSerpent: true, tempestGale: true, thrashingDragon: true, unquietGrave: true, veiledMoon: true, heartOfTheMaelstrom: true, burningCitadel: true, shadowAssassin:true, indomitableWill:true, crimsonReaper:true, sterlingSovereignty:true,}
        }
        if(message.options && message.options.includeSubschool){
          options.includeSubschool = message.options.includeSubschool
        }
        if(message.options && message.options.onlySubschool){
          options.onlySubschool = message.options.onlySubschool
        }
        if(message.options && message.options.onlyFinisher){
          options.onlyFinisher = message.options.onlyFinisher
        }
        if(message.options && message.options.level){
          options.level = message.options.level
        }else{
          let lvlNum = Math.ceil(player.characterSheet.characterStats.misc.level/2)+1
          if(lvlNum > 9)lvlNum = 9
          let levels = {level:{}}
          for(let x = 0; x < 4; x++){
              if(lvlNum-x >= 1){   
                  let level = lvlNum-x
                  let levelString="lvl"+level;
                  levels.level[levelString]=true;
              }
          }
          options.level = levels.level
          options.level.lvl0 = false
          options.overrideLevel = false
        }
        if(message.options && message.options.type){
          options.type = message.options.type
        }else{
          options.type={Boost:true,Counter:true,Stance:true,Strike:true, Finisher:true,}
        }
      }else if(message.type=="spell"){
        message.type="spells"
        if(message.options && message.options.level){
          options.level=message.options.level
        }else{
          let lvlNum = Math.ceil(player.characterSheet.characterStats.misc.level/2)+1
          if(lvlNum > 9){lvlNum = 9}
          let levels = {level:{}}
          for(let x = 0; x < 4; x++){
              if(lvlNum-x >= 0){   
                  let level = lvlNum-x
                  let levelString="lvl"+level;
                  levels.level[levelString]=true;
              }
          }
          options.overrideLevel = false
          options.level = levels.level
        }
        if(message.options && message.options.type){
          options.type = message.options.type
        }else{
          options.type = {damage:true, utility:true, control:true, healing:true, buff:true}
        }
        if(message.options && message.options.tags){
          options.tags = message.options.tags 
        }
        if(message.options && message.options.school){
          options.school = message.options.school
        }
        //console.log(options)
      }else if(message.type.includes("lvl1") || message.type.includes("lvl2")){        
        if(message.type.substring(4) != "spell"){
          options.type = {}
          options.type[message.type.substring(4)] = true
        }else{
          options.type = {damage:true, utility:true, control:true, healing:true, buff:true}
        }        
        options.level={}
        options.level[message.type.substring(0,4)] = true
        message.type="spells"
      }else if(message.type=="enchanted weapon"){
        message.type="weapon"
        options.weapon = {}
        options.weaponEnchantments = {}
        options.weapon.rarity={common:true, rare:true,epic:true,legendary:true}
        options.weapon.type={augmenting:true, light: true, oneHanded:true, twoHanded:true, primitive:true, tech:true, armament:true}
        options.weapon.class={melee:true, ranged:true, armament:true, enchanted:true}
        options.weaponEnchantments.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        options.weaponEnchantments.class={melee:true, ranged:true, armament:true}
      }else if(message.type=="enchanted armor"){
        message.type="armor"
        options.armor={
          type:{clothing:true,light:true,medium:true,heavy:true,shield:true},
          rarity:{common:true, rare:true,epic:true,legendary:true,unique:true},
          enchanted:true
          }
        options.armorEnchantments={common:true, rare:true,epic:true,legendary:true,unique:true}
      }else if(message.type=="Level Up"){
        this.levelUp(player)
        return
      }else if(message.type=="Teamwork Feat"){
        message.type="feats"
        options={martial:false, magic:false, utility:false,metamagic:false, teamwork:true}
      }else if(message.type=="weapon enchantment"){
        //console.log("message", message)
        options.weaponEnchantments = {}
        if(message.options && message.options.weaponEnchantments.rarity){
          options.weaponEnchantments.rarity = message.options.weaponEnchantments.rarity
        }else{
          options.weaponEnchantments.rarity={common:true, rare:true, epic:true, legendary:true, unique:true}
        }
        if(message.options && message.options.weaponEnchantments.class){
          options.weaponEnchantments.class = message.options.weaponEnchantments.class
        }else{
          options.weaponEnchantments.class = {melee:true, ranged:true, armament:true}
        }

        let newMessage = {}
        newMessage.data = options.weaponEnchantments
        newMessage.command = 'newRoll'
        newMessage.type = 'requestWeapon'
        this.sendData(newMessage, player);        
        return
      } else if(message.type=="armor enchantment"){
          message.type="armorEnchantments"
        if(message.options && message.options.armorEnchantments && message.options.armorEnchantments.rarity){
          options.armorEnchantments = message.options.armorEnchantments.rarity
        }else{
          options.armorEnchantments ={common:true, rare:true, epic:true, legendary:true, unique:true}
        }
        options.armor={clothing:true,light:true,medium:true,heavy:true,shield:true,enchanted:false}                  
      } else if(message.type=="alignment"){
            //console.log("")
      }
      else if(message.type=="race"){
        //console.lg()
      }
      else if(message.type =="Recovery Perk"){
         message.type="perks"
          options.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
          options.type={martial:true, magic:true,universal:true}
          options.sub= {ragePerks: false, gambits: false, roguePerks: false, kiPerks: false, fighterPerks: false, recoveryPerks:true}
      }
      else if(message.type=="Rage Power"){
        message.type="perks"
        options.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        options.type={martial:true, magic:true,universal:true}
        options.sub= {ragePerks: true, gambits: false, roguePerks: false, kiPerks: false, fighterPerks: false}
      }else if(message.type=="Rogue Talent"){
        message.type="perks"
        options.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        options.type={martial:true, magic:true,universal:true}
        options.sub= {ragePerks: false, gambits: false, roguePerks: true, kiPerks: false, fighterPerks: false}
      }else if(message.type=="Ki power" || message.type=="Ki Power"){
        message.type="perks"
        options.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        options.type={martial:true, magic:true,universal:true}
        options.sub= {ragePerks: false, gambits: false, roguePerks: false, kiPerks: true, fighterPerks: false}
      }else if(message.type=="Fighter Perk"){
        message.type="perks"
        options.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        options.type={martial:true, magic:true,universal:true}
        options.sub= {ragePerks: false, gambits: false, roguePerks: false, kiPerks: false, fighterPerks: true}
      }else if(message.type=="Gambit"){
        message.type="perks"
        options.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        options.type={martial:true, magic:true,universal:true}
        options.sub= {ragePerks: false, gambits: true, roguePerks: false, kiPerks: false, fighterPerks: false}
      }else if(message.type=="wonderousItems"){
        message.type="wonderousItems"
        if(message.options && message.options.rarity){
          options.rarity = message.options.rarity
        }else{
          options.rarity={common:true, rare:true,epic:true,legendary:true,unique:true}
        }
        if(message.options && message.options.type){
          options.type = message.options.type
        }else{
          options.type={ring: true, neck:true, eyes:true, belt:true, hands:true, wrist:true, shoulders:true, chest:true, headband:true, body:true, feet:true, head:true,untyped:true}
        }
      }else if(message.type=="Gear"){
        let options = {}
        if(message.options && message.options.type){
          options.type = message.options.type
        }else{
          options.type = {ammunition:true,grenade:true,blanch:true,utility:true,implement:true}
        }
        let gear = this.getRoll("global",'gear', options)
        this.giveGear(gear, gear.stack)
        return
      }else if(message.type=="potions"){
        let options = {}
        if(message.options && message.options.type){
          options.type = message.options.type
        }else{
          options.type = {curative:true,mnemonic:true,restorative:true}
        }
        options.level = Math.ceil(player.characterSheet.characterStats.misc.level/2)
        if(message.options && message.options.level){
          options.level = message.options.level
        }
        let count = 1
        if(message.options && message.options.count){
          count = message.options.count
        }
        let gear = this.getRoll("global",'potions', options, count)
        this.givePotion(gear[0], 1)
        return
      }else{
        console.log("ignored a rollRequest", message.type)
        return
      }                  
      let playerNames = this.players.map(player => player.playerName)
      let filteredPlayerNames = playerNames.filter(name => name != player.playerName)
      let playerFeats = []
      let playerPerks = []
      if(player.characterSheet && player.characterSheet.lists){
        if(player.characterSheet.lists.feats){
          playerFeats = player.characterSheet.lists.feats.map(feat=>feat.name)        
        }
        if(player.characterSheet.lists.perks){
          playerPerks = player.characterSheet.lists.perks.map(perk=>perk.name)        
        }
      }
      let response = {}
      let rollAmount = this.rollAmount
      if(message.rollAmount){
        rollAmount = message.rollAmount
      }
      response.options = this.getRoll(player.playerName, message.type, options, rollAmount, playerFeats, playerPerks, filteredPlayerNames)
      response.id = message.id
      response.command = 'newRoll'
      response.type = message.type
      //player.senderConnection.send(JSON.stringify(response))  
      this.sendData(response, player)    
    },

    requestWeaponEnchantment(message, player){
      let rollOptions = {}
       rollOptions.weaponEnchantments = message.options
       if(message.weapon.class == "melee"){
         rollOptions.weaponEnchantments.class.ranged = false
         rollOptions.weaponEnchantments.class.armament = false
       }else if(message.weapon.class == "ranged"){
         rollOptions.weaponEnchantments.class.melee = false
         rollOptions.weaponEnchantments.class.armament = false
       }else if(message.weapon.class == "armament"){
         rollOptions.weaponEnchantments.class.melee = false
         rollOptions.weaponEnchantments.class.ranged = false
       }
      Object.entries(rollOptions.weaponEnchantments.class).forEach((entry)=>{
        if(entry[0] != message.weapon.class && entry[0] != 'all'){
          entry[1] = false
        }
      })     
      let response = {} 
      response.options = dataGenerator.roll('weaponEnchantments', rollOptions, this.rollAmount)
      this.rollIds += this.rollAmount +1
      response.weapon = message.weapon
      response.id = message.id
      response.command = 'newRoll'
      response.type = 'weaponEnchantment'
      player.senderConnection.send(JSON.stringify(response))
      if(message.options && message.type !="requestWeapon" && message.type !="weaponEnchantment"){
          player.remainingRolls.splice(player.remainingRolls.length, 0, response)
        }
      //this.sendData(message, player)
    },

    capNumber(type){
      this[type].modifierAmount = parseInt(this[type].modifierAmount) > 7 ? 7 : this[type].modifierAmount
      this[type].modifierAmount = parseInt(this[type].modifierAmount) < -9 ? -9 : this[type].modifierAmount
    },

    levelUp(sendTarget){
       this.players.forEach((player) => {
        let level = player.characterSheet.characterStats.misc.level+1
        let rarity = {common:true,rare:true,epic:true,legendary:true,unique:true}
         //console.log("send target", sendTarget, "playername", player)
         if((sendTarget && player.playerName == sendTarget.playerName) || (sendTarget==undefined && (this.sendTargets.includes(player.playerName) || this.sendTargets.includes("all")))) {
            let message = {command:'newRoll', type:"levelUp"}
            this.sendData(message, player)

            let rollOptions={rarity:{common:true, rare:true, epic:true, legendary:true,unique:true}, type:{abilityScore:true, misc:true, skills:true}}
            
            options = this.getRoll(player.playerName, "stats", rollOptions, this.rollAmount)
            message = {command:'newRoll', type:"stats", options}
            this.sendData(message, player);

            let options = this.getRoll(player.playerName, 'levelUp', {type:"abilityScore", rarity}, this.rollAmount)
            message = {command:'newRoll', type:"stats", options}
            this.sendData(message, player)        

            options = this.getRoll(player.playerName, 'levelUp', {type:"skill", rarity:{common:true,rare:true,epic:true}}, this.rollAmount)
            message = {command:'newRoll', type:"stats", options}
            this.sendData(message, player)

            options = this.getRoll(player.playerName, 'levelUp', {type:"skill", rarity}, this.rollAmount)
            message = {command:'newRoll', type:"stats", options}
            this.sendData(message, player)
            
            if(level%2==1){
              let message = {}
              message.type="Feat"
              message.options = {martial:true, magic:true, utility:true,metamagic:true, teamwork:true}
              this.requestRoll(message, player)
            }

            // if(level%8==0){
            //   let message = {}
            //   message.type="Perk"
            //   message.options = {rarity:{common:true,rare:true,epic:true,legendary:true}}
            //   this.requestRoll(message, player)
            // }

            if(level%5==0){
              let message = {}
              message.type="Perk"
              message.options = {rarity:{common:true,rare:true}}
              this.requestRoll(message, player)
            }

            if(level%2==1){
              options = this.getRoll(player.playerName, 'levelUp', {type:"save", rarity:{rare:true,epic:true,legendary:true,unique:true}}, this.rollAmount)
              message = {command:'newRoll', type:"stats", options}
              this.sendData(message, player)
            }else{
              options = this.getRoll(player.playerName, 'levelUp', {type:"save", rarity:{rare:true}}, this.rollAmount)
              message = {command:'newRoll', type:"stats", options}
              this.sendData(message, player)
            }
         }
       })
    },

    givePotion(potion, count){
      if(!count) count = 1
      potion.count = this.potions[potion.id-1].count += count
      this.potions.splice(potion.id-1, 1, potion)
      let message = {command:"communalUpdate", type:"potion", potion}
      this.players.forEach((player) => {
        this.sendData(message, player);
      })
    },

    giveGold(){      
      if(!isNaN(this.goldAmount) && this.goldAmount.trim() != ""){
        this.players.forEach((player) => {
          if(this.sendTargets.includes(player.playerName) || this.sendTargets.includes("all")) {
            this.sendData({command:"newRoll", type:"gold", amount: this.goldAmount}, player)
          }
        })
      }
    },

    randomPotions(){
      let range = parseInt(this.potionOptions.amount.potionMax) - parseInt(this.potionOptions.amount.potionMin)
      let amount = parseInt(this.potionOptions.amount.potionMin) + Math.round(Math.random() * range)
      let types = []
      Object.keys(this.potionOptions.types).forEach(type=>{
        //console.log(type, this.potionOptions.types, this.potionOptions.types[type])
        if(this.potionOptions.types[type]){
          types.push(type)
        }
      })
      let levels = this.players.map(player => player.characterSheet.characterStats.misc.level)
      let highestLevel = Math.ceil(levels.sort(function(a, b){return b-a})[0]/2)
      let potions = []
      for(let x = 0; x < amount; x++){
        let type = types[Math.floor(Math.random() * types.length)]
        let options = {type, level: highestLevel, ignoreLevel:this.potionOptions.amount.ignoreLevel}
        potions.push(dataGenerator.roll("potions", options, 1)[0])
      }
      let log = ""
      potions.forEach(potion=>{
        this.givePotion(potion)
        log +=" " + potion.name + ", "
      })
      this.logs.unshift({id:this.logs.length-1, text:"rolled " + amount + " potions:" + log})
    },

    giveXP(){
      if(!isNaN(this.xpAmount)  && this.xpAmount.trim() != "" ){   
        let sendCount
        if(this.targetSendXp){
          sendCount = this.sendTargets.length
        }else{
          sendCount = this.players.length
        }     
        let xpAmount = Math.ceil(this.xpAmount/sendCount)
        this.players.forEach((player) => {
          if(!this.targetSendXp || this.sendTargets.includes(player.playerName)) {
            this.sendData({command:"newRoll", type:"xp", amount: xpAmount, ignoreLeveling:this.ignoreLeveling}, player)
          }
        })
        this.logs.unshift({id:this.logs.length-1, text:"Gave "+ xpAmount + "("+ this.xpAmount + ")" + "experience"})
      }
    },

    rollLoot(size){
      let levels = this.players.map(player => player.characterSheet.characterStats.misc.level)
      let highestLevel = levels.sort(function(a, b){return b-a})[0]
      let options = {size, level:highestLevel}
      let loot = this.getRoll("global",'loot', options)
      let potionString = ""
      loot.potions.forEach(potion =>{
        if(potion){
          potionString += potion.name + " + "
          this.givePotion(potion)
        }
      })
      if(loot.gear >= 1){
        this.rollGear(loot.gear)
      }
      potionString = potionString.substring(0,potionString.length-3)
      let goldAmount = Math.ceil(loot.goldAmount/this.players.length)
      this.logs.unshift({id:this.logs.length-1, text:"Rolled a "+ size +" loot pile and party got " + goldAmount  + "("+ loot.goldAmount + ")" +" gold and " + potionString})
      this.players.forEach((player) => {
        this.sendData({command:"newRoll", type:"gold", info:"size", amount: goldAmount}, player)
      })
      if(loot.item){
        this.players.forEach((player) => {
          this.sendData({command:"communalUpdate", type:"wonderousItem", item:loot.item}, player)
        })
        this.logs.unshift({id:this.logs.length-1, text:"Pile rolled a wonderous item: " + loot.item.name})
      }
    },

    rollGear(setAmount){
      let range = parseInt(this.gear.amount.gearMax) - parseInt(this.gear.amount.gearMin)
      let amount = setAmount >= 1 ? setAmount : parseInt(this.gear.amount.gearMin) + Math.round(Math.random() * range)
      let allGear = []
      for(let x = 0; x < amount; x++){
        let gear = this.getRoll("global",'gear', this.gear)
        this.giveGear(gear, gear.stack)
        allGear.push(gear)
      }
      let log = ""
      for(let x = 0; x < allGear.length; x++){
        log +=" " + allGear[x].name + ", "        
      }
      this.logs.unshift({id:this.logs.length-1, text:"rolled " + amount + " Gear:" + log})
    },

    giveGear(gear, count){
      let index = this.playerGear.findIndex(playerGear=> playerGear.name == gear.name)
      if(index == -1){
        this.playerGear.splice(0,0, gear)
      }else{
        let temp = this.playerGear[index]
        if(gear.name == "Masterwork Tool"){
          temp = JSON.parse(JSON.stringify(temp))
          this.getRoll("global", "masterworkTool", temp)   
          temp.count = 1
          this.giveGear(temp,1)
        }else if(gear.name == "Metamagic Rod"){
          temp = JSON.parse(JSON.stringify(temp))
          this.getRoll("global", "metamagicRod", temp)
          temp.count = 1
          this.giveGear(temp,1)
        }else{
          temp.count += count
          this.playerGear.splice(index, 1, temp)
          gear = temp
        }        
      }
      let message = {command:"communalUpdate", type:"gear", gear: gear}
      this.players.forEach((player) => {
          this.sendData(message, player);
        })
    },

    rollPartyDrop(){
      let item = this.getRoll("none","wonderousItems", this.wonderousItems, 1)[0]
      item.uiType="wonderousItems"
      this.players.forEach((player) => {
        this.sendData({command:"communalUpdate", type:"wonderousItem", item}, player)
      })
    },

    
    
    getRoll(target, type, options, amount, playerFeats, playerPerks, filteredPlayerNames){
      console.log("ran though", target, type, options, amount, playerFeats, playerPerks, filteredPlayerNames)
     // try{
        let roll = dataGenerator.roll(type, options, amount, playerFeats, playerPerks, filteredPlayerNames)
        //console.log("roll", roll)
        return roll
      // }catch(err){
      //   this.newError.new = true
      //   this.newError.type = type
      //   this.newError.target = target
      // }
    },

    select: function(event){
      event.target.setSelectionRange(0, this.textLength)
    },

    swapStore(){
      this.storeOpen = !this.storeOpen
    },

    getItemList(object,start,count){
      let keys = Object.keys(object)
      return keys.slice(start,count)
    },

    maybeToggle(object, key){
      if(this.mouseDown){
        object[key] = !object[key]
      }      
    },

    capitalize(str){  
    for(let x = 0; x < str.length; x++){
      if(str[x].toUpperCase() == str[x]){
        str = str.substring(0,x) + " " + str.substring(x,str.length)
        x++
      }
    }
    let newStr = str[0].toUpperCase() + str.substring(1)
    return newStr
  },
    
    openStoreDialog(){
      this.storeDialog = true
      this.storeCommand = {type:"update"}
    },

    unselectSub(type){ 
      let keys = Object.keys(this.perks.sub)
      keys.forEach(key =>{
        if(key != type){
          this.perks.sub[key] = false
        }
      })      
      if(type != "forbidden"){
        this.perks.rarity.forbidden = false
      }
    },

    // sendBoughtItem(player, item){

    //   switch (item.type){
    //     case "weapon":
    //       let message = {type:"weapon", option:"class"}
    //       this.requestRoll(message, player)
    //       break
    //     case "armor":

    //     case "weaponEnchantment":
    //     case "armorEnchantment":
    //     case "perk":
    //     case "feat":
    //     case "spell":
    //     case "maneuver":
    //     case "potion":
    //   }
    // }

  },
}
//v-messages.theme--light.primary--text
</script>
<style>
.small-label .v-label{
  font-size:12px;
  margin-top:0px;
  margin-bottom:0px;
  padding-top:0px;
}
.small-label .v-messages.theme--light{
  height:0px;
  display:none;
}
.small-label .v-input--selection-controls__input{
  margin-right: 0px !important
}
.color-tab .v-tabs-bar{
  background-color: #e0e0e0!important;
  height:40px;
}

.small-tab .v-tabs-bar{
  height:30px;
}
.background .v-image__image{
  background-repeat: round !important;
  background-size: contain !important; 
}
.dark-label .theme--light.v-label{
  color: #000;
}
.light::-webkit-scrollbar {
  width: 8px;
}

.light::-webkit-scrollbar-track {
  background: rgb(0,0,0,0);
}

.light::-webkit-scrollbar-thumb {
  background: rgb(89, 58, 52);  
  border-radius: 7px;
}

.light .v-input__slot::-webkit-scrollbar{
  width: 8px;
}
.firefoxScroll{
  scrollbar-color: sienna transparent;
  scrollbar-width: thin;
}
.custom-autocomplete.v-list, .v-select-list {
  max-height: 300px !important;
  overflow-y: auto !important;
}
.absolute-hint .v-text-field__details{
  position: absolute;
  top: 100%;
}
.absolute-hint .v-messages__message{
  font-size: 14px;
  color: rgb(0, 0, 0);
}

</style>
